import { render, staticRenderFns } from "./BookCard.vue?vue&type=template&id=d4f86360&scoped=true&"
import script from "./BookCard.vue?vue&type=script&lang=js&"
export * from "./BookCard.vue?vue&type=script&lang=js&"
import style0 from "./BookCard.vue?vue&type=style&index=0&id=d4f86360&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4f86360",
  null
  
)

export default component.exports